import React from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../Redux/Features/Card/actions";
import { prodQuetyDecrement } from "../Redux/Features/ProductsPage/actions";
const SingleProduct = ({ prod }) => {
 const dispatch = useDispatch();

 const { name, category, prodImg, prodPrice, prodQuantity } = prod || {};

 const HandleAddToCart = (prod) => {
  const prodObj = {
   id: prod.id,
   name: prod.name,
   category: prod.category,
   prodImg: prod.prodImg,
   prodPrice: prod.prodPrice,
   prodQuantity: 1,
   stock: prodQuantity - 1,
  };
  dispatch(addToCart(prod.id, prodObj));
  dispatch(prodQuetyDecrement(prod.id));
 };
 return (
  <div>
   <div className="lws-productCard">
    <img className="lws-productImage" src={prodImg} alt="product" />
    <div className="p-4 space-y-2">
     <h4 className="lws-productName">{name}</h4>
     <p className="lws-productCategory">{category}</p>
     <div className="flex items-center justify-between pb-2">
      <p className="productPrice">
       BDT <span className="lws-price">{prodPrice}</span>
      </p>
      <p className="productQuantity">
       QTY <span className="lws-quantity">{prodQuantity}</span>
      </p>
     </div>
     <button
      className="lws-btnAddToCart"
      onClick={() => HandleAddToCart(prod)}
      disabled={prodQuantity === 0}
     >
      Add To Cart
     </button>
    </div>
   </div>
  </div>
 );
};

export default SingleProduct;
